module.exports = __webpack_public_path__ + "static/g300x375-a73f6cf3d4c634d01ac6ead2b45899a1.png";